import React from 'react';
import Slider from '../rangeslider'
import {openModal} from '../../api/modals/actions'

class LineHeightSelector extends React.Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            lineHeight: this.props.lineHeight
        }
    }

    handleOnChange(value){
        if (!this.props.user.hasSubscription) {
            this.props.dispatch(openModal("modal-paywall", "line-height"))
        }
        else {
            this.setState({
            lineHeight: value
            })
        }
    }

    handleOnChangeComplete(e){
        this.props.onChange(this.state.lineHeight);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.lineHeight !== prevProps.lineHeight) {
            this.setState({lineHeight: this.props.lineHeight})
        }
    }

    render() {
        let { lineHeight } = this.state
        return (
          <Slider
            value={lineHeight}
            onChange={this.handleOnChange.bind(this)}
            onChangeComplete={this.handleOnChangeComplete.bind(this)}
            min={0}
            max={4}
            tooltip={false}
            labels={{0:<span className="label-small">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256"><path d="M128,128a8,8,0,0,1-8,8H48a8,8,0,0,1,0-16h72A8,8,0,0,1,128,128ZM48,72H184a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16Zm56,112H48a8,8,0,0,0,0,16h56a8,8,0,0,0,0-16Zm125.66-21.66a8,8,0,0,0-11.32,0L192,188.69V112a8,8,0,0,0-16,0v76.69l-26.34-26.35a8,8,0,0,0-11.32,11.32l40,40a8,8,0,0,0,11.32,0l40-40A8,8,0,0,0,229.66,162.34Z"></path></svg>
                </span>, 
                100:<span className="label-large">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256"><path d="M40,128a8,8,0,0,1,8-8h72a8,8,0,0,1,0,16H48A8,8,0,0,1,40,128Zm8-56h56a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16ZM184,184H48a8,8,0,0,0,0,16H184a8,8,0,0,0,0-16ZM229.66,82.34l-40-40a8,8,0,0,0-11.32,0l-40,40a8,8,0,0,0,11.32,11.32L176,67.31V144a8,8,0,0,0,16,0V67.31l26.34,26.35a8,8,0,0,0,11.32-11.32Z"></path></svg>
                </span>}}
          />
        )
    }
}

LineHeightSelector.defaultProps = {
    lineHeight: 2
}

  export default LineHeightSelector;